var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createRef, useState } from 'react';
import { useAnimateTransition, useId } from '../hooks';
import { Overlay } from '../overlay';
import { Portal } from '../portal';
import { ModalProvider } from './modal-context';
import Panel from './panel';
function ModalInternal(_a) {
    var { alignCenter = false, 'aria-label': ariaLabel, children, context, disableOverlay = false, disablePortal = false, floatingProps, isOpen, size = 'medium' } = _a, restProps = __rest(_a, ["alignCenter", 'aria-label', "children", "context", "disableOverlay", "disablePortal", "floatingProps", "isOpen", "size"]);
    const id = `modal-${useId()}`;
    const isAnimating = useAnimateTransition(isOpen, 300);
    const autoFocusRef = createRef();
    const [headerId, setHeaderId] = useState();
    const [bodyId, setBodyId] = useState();
    const [hasDecorativeHeader, setHasDecorativeHeader] = useState(false);
    function renderContent() {
        const panelProps = Object.assign({ ariaLabel,
            children,
            context,
            floatingProps, isVisible: isOpen }, restProps);
        return disableOverlay ? (_jsx(Panel, Object.assign({}, panelProps))) : (_jsx(Overlay, Object.assign({ "data-testid": "modal-overlay", isVisible: isOpen }, { children: _jsx(Panel, Object.assign({}, panelProps)) })));
    }
    return (_jsx(ModalProvider, Object.assign({}, {
        alignCenter,
        autoFocusRef,
        bodyId,
        hasDecorativeHeader,
        headerId,
        id,
        setBodyId,
        setHasDecorativeHeader,
        setHeaderId,
        size,
    }, { children: disablePortal ? (isAnimating && renderContent()) : (_jsx(Portal, { children: isAnimating && renderContent() })) })));
}
export default ModalInternal;
